import { useEffect, useState } from "react";
import { ReactComponent as InfoIcon } from "../../../assets/svg/icons/info.svg";
import { Loading } from "../../Loading/Index";
import InfoFailSync from "../../Tasks/ViewTasks/InfoFailSync";
import "./styles.css"
import { formatDateToCustomFormat } from "../../../utils/date/formatedDate";
import { ReactComponent as ArrowIcon } from "../../../assets/svg/icons/rightChevron.svg"
import { useTableMonitor } from "../../../hooks/useTableMonitor";

type FailSyncTableProps = {
  listTable: IFailSync[];
  isLoading: boolean;
};


export default function FailSyncTable({
  listTable,
  isLoading
}: FailSyncTableProps) {
  const [selectedId, setSelectedId] = useState(0);
  const { selectedOrder, setSelectedOrder, sortAsc, setSortAsc } = useTableMonitor();

  useEffect(() => {
    setSelectedOrder("createdAt")
  }, []);

  return (
    <>
      {listTable.length != 0 ?
        <>
          <table className="tableTaskEvaluation" style={{ minWidth: 720 }}>
            <thead>
              <tr>
                {[
                  { key: "user", label: "Usuário" },
                  { key: "createdAt", label: "Data" }
                ].map(({ label, key }) => (
                  <th
                    key={key}
                    onClick={() => {
                      setSelectedOrder(key);
                      if (selectedOrder !== key) {
                        setSortAsc(false);
                        return;
                      }
                      setSortAsc(!sortAsc);
                    }}
                  >
                    <div className="infoColumn">
                      {label}
                      <ArrowIcon
                        className={`iconSort${sortAsc ? "--asc" : ""}`}
                        style={{
                          display: selectedOrder === key ? "block" : "none",
                        }}
                      />
                    </div>
                  </th>
                ))}
                <th />
              </tr>
            </thead>
            <tbody>
              {listTable.map(rowData => {
                const date = new Date(rowData.date);

                return (
                  <tr>
                    <td>
                      {rowData.name}
                    </td>
                    <td>
                      {date ? formatDateToCustomFormat(date) : ""}
                    </td>
                    <td style={{
                      cursor: "pointer",
                    }}>
                      <InfoIcon
                        onClick={() => {
                          setSelectedId(rowData.id)
                        }}
                      />
                    </td>
                  </tr>
                )
              }
              )}
            </tbody>
          </table>
          {isLoading && (
            <div className="tableLoadingOverlay" style={{ minWidth: 1400 }}>
              <div className="lds-ring">
                <div></div>
                <div></div>
              </div>
            </div>
          )}
        </>
        :
        <div className="emptyTable_container">
          <span>Nenhum resultado encontrado.</span>
        </div>
      }
      <InfoFailSync
        selected={selectedId}
        setSelectedId={setSelectedId}
      />
    </>
  );
}